
import { supabase } from './supabaseClient';

/**
 * Verifica se o usuário logado é administrador
 * Retorna true se for admin, false caso contrário
 */
export async function verificarSeAdmin(userId?: string): Promise<boolean> {
  try {
    let uid = userId;
    if (!uid) {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;
      uid = user.id;
    }

    const { data: profile, error } = await supabase
      .from('profiles')
      .select('is_admin, plano')
      .eq('id', uid)
      .maybeSingle();

    if (error || !profile) return false;

    return profile.is_admin === true || profile.plano === 'premium';
  } catch (error) {
    console.error('Erro ao verificar admin:', error);
    return false;
  }
}

// Alias para compatibilidade
export const verificarAdmin = verificarSeAdmin;

/**
 * Hook-friendly: retorna objeto com informações de acesso
 */
export async function obterNivelAcesso(userId?: string): Promise<{
  isAdmin: boolean;
  plano: string;
  acessoTotal: boolean;
}> {
  try {
    let uid = userId;
    if (!uid) {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return { isAdmin: false, plano: 'free', acessoTotal: false };
      uid = user.id;
    }

    const { data: profile, error } = await supabase
      .from('profiles')
      .select('is_admin, plano')
      .eq('id', uid)
      .maybeSingle();

    if (error || !profile) {
      return { isAdmin: false, plano: 'free', acessoTotal: false };
    }

    const isAdmin = profile.is_admin === true;
    const plano = profile.plano || 'free';
    const acessoTotal = isAdmin || plano === 'premium';

    return { isAdmin, plano, acessoTotal };
  } catch (error) {
    console.error('Erro ao obter nível de acesso:', error);
    return { isAdmin: false, plano: 'free', acessoTotal: false };
  }
}
